<template>
  <b-overlay
    :style="{ minHeight: '300px' }"
    :show="loading.comment"
    rounded="sm"
    class="ticket-card-comments"
  >
    <span v-if="comments.length !== 0"><strong>Комментарии</strong></span>
    <Comment
      v-for="(comment, idx) in comments"
      :key="idx"
      :id-comment="comment.ID"
      :created-at="comment.CREATED_AT | formattedDateTime"
      :user-id="comment.B2B_USER_ID"
      :avatar-path="comment.AVATAR_PATH"
      :user-name="comment.B2B_FEATURES.B2B_USER_NAME || 'Сотрудник B2С'"
      :text="comment.COMMENT"
      @remove="deleteComment"
    />
  </b-overlay>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Comment from "@components/comments/Comment.vue";
export default {
  components: {
    Comment,
  },

  computed: {
    ...mapGetters("tickets", ["ticket", "loading"]),
    ...mapGetters(["allUsers"]),

    comments() {
      return this.ticket.get_comments.map(comment => {
          this.allUsers.forEach(name => {
              if ( name.value === Number(comment.B2B_USER_ID) ) {
                  comment.B2B_USER_NAME = name.text
              }

          })
          return comment
      });
    },
  },

  methods: {
    ...mapActions("tickets", ["createComment", "deleteComment"]),
  },
};
</script>
